import { ChangePasswordPolicyType } from "../../types/User";
import { get, patch, put } from "../../utils/axios-config";
import { GET_PASSWORD_POLICY, PASSWORD_POLICIES_CHANGE_POLICY } from "../../utils/constants";

export const changePasswordPolicy = async (data: ChangePasswordPolicyType) => await put<ChangePasswordPolicyType, string>(PASSWORD_POLICIES_CHANGE_POLICY, data);
export const getPasswordPolicy = async () => await get<ChangePasswordPolicyType>(GET_PASSWORD_POLICY);